var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1868 8.33301L6.375 13.947L15.1868 19.561L24 13.947L15.1868 8.33301Z",
    fill: "#0061FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8126 8.33301L24 13.9475L32.8126 19.5621L41.6251 13.9475L32.8126 8.33301Z",
    fill: "#0061FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 25.1765L15.1868 30.7905L24 25.1765L15.1868 19.5625L6.375 25.1765Z",
    fill: "#0061FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 19.5625L24 25.177L32.8125 30.7915L41.625 25.177L32.8125 19.5625Z",
    fill: "#0061FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 32.6736L24.0007 38.2876L32.8125 32.6736L24.0007 27.0596L15.1875 32.6736Z",
    fill: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropLogo);
export default __webpack_public_path__ + "static/media/dropLogo.404523d1058c4b64727abb503ff0f2cd.svg";
export { ForwardRef as ReactComponent };